import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import './GypsumCeilingSolutions.css';
import QuoteForm from '../../components/QuoteForm';
import SEO from '../../components/SEO';

import Hada9mmImage from '../../assets/Gypsum ceilng Solutions/HadaGyp1.webp';
import Hada12mmImage from '../../assets/Gypsum ceilng Solutions/HadaGy2.webp';
import Knauf9mmImage from '../../assets/Gypsum ceilng Solutions/KnaufGy1.webp';
import Knauf12mmImage from '../../assets/Gypsum ceilng Solutions/KnaufGy2.webp';
import Gyproc9mmImage from '../../assets/Gypsum ceilng Solutions/GyprocGypsum.jpeg';
import Gyproc12mmImage from '../../assets/Gypsum ceilng Solutions/WhatsApp Image 2026-05-02 at 21.51.42.webp';
import Moisture9mmImage from '../../assets/Gypsum ceilng Solutions/MoistureRestant1.webp';
import Moisture12mmImage from '../../assets/Gypsum ceilng Solutions/MoistureRest2.webp';
import ProjectImage1 from '../../assets/GypsumCeilngProjects/WhatsApp Image 2026-05-02 at 21.34.40 (1).webp';
import ProjectImage2 from '../../assets/GypsumCeilngProjects/WhatsApp Image 2026-05-02 at 21.34.40.webp';
import ProjectImage3 from '../../assets/GypsumCeilngProjects/WhatsApp Image 2026-05-02 at 21.34.41.webp';
import ProjectImage4 from '../../assets/GypsumCeilngProjects/WhatsApp Image 2026-05-02 at 21.34.45.webp';
import ProjectImage5 from '../../assets/GypsumCeilngProjects/WhatsApp Image 2026-05-02 at 21.34.46.webp';
import ProjectVideo1 from '../../assets/GypsumCeilngProjects/WhatsApp Video 2026-04-29 at 22.06.05.mp4';
import ProjectVideo2 from '../../assets/GypsumCeilngProjects/WhatsApp Video 2026-04-29 at 22.06.20.mp4';

const PROJECT_SHOWCASE = [
  { type: 'image', src: ProjectImage1, alt: 'Gypsum ceiling project image 1' },
  { type: 'image', src: ProjectImage2, alt: 'Gypsum ceiling project image 2' },
  { type: 'image', src: ProjectImage3, alt: 'Gypsum ceiling project image 3' },
  { type: 'image', src: ProjectImage4, alt: 'Gypsum ceiling project image 4' },
  { type: 'image', src: ProjectImage5, alt: 'Gypsum ceiling project image 5' },
  { type: 'video', src: ProjectVideo1, alt: 'Gypsum ceiling project video 1' },
  { type: 'video', src: ProjectVideo2, alt: 'Gypsum ceiling project video 2' }
];

const GypsumCeilingSolutions = () => {
  const [activeImageIndex, setActiveImageIndex] = useState(null);
  const services = [
    'Flat gypsum ceilings',
    'Bulkheads and drop ceilings',
    'Curtain boxes',
    'Decorative and custom ceiling designs',
    'LED lighting integration',
    'Ceiling repairs and renovations'
  ];

  const benefits = [
    'Enhances interior appearance instantly',
    'Improves lighting and ambience',
    'Conceals wiring and structural imperfections',
    'Durable and low-maintenance finish',
    'Fully customizable to match your style'
  ];

  const gypsumTypes = [
    {
      title: 'Hada 9mm Gypsum Board',
      description: 'Ideal for standard ceiling installations, offering a smooth finish and easy workability.',
      image: Hada9mmImage
    },
    {
      title: 'Hada 12mm Gypsum Board',
      description: 'Stronger board recommended for partitions and areas requiring added rigidity.',
      image: Hada12mmImage
    },
    {
      title: 'Knauf 9mm Gypsum Board',
      description: 'Lightweight and ideal for modern ceiling systems with excellent finishing quality.',
      image: Knauf9mmImage
    },
    {
      title: 'Knauf 12mm Gypsum Board',
      description: 'High-strength board suitable for partitions, bulkheads, and heavy-duty interior applications.',
      image: Knauf12mmImage
    },
    {
      title: 'Gyproc 9mm Gypsum Board',
      description: 'Perfect for suspended ceilings and decorative ceiling designs.',
      image: Gyproc9mmImage
    },
    {
      title: 'Gyproc 12mm Gypsum Board',
      description: 'Recommended for partition walls and reinforced ceiling systems.',
      image: Gyproc12mmImage
    },
    {
      title: 'Moisture Resistant Board 9mm',
      description: 'Ideal for bathroom ceilings, kitchens, laundry areas, and other humid spaces requiring lightweight moisture protection.',
      image: Moisture9mmImage
    },
    {
      title: 'Moisture Resistant Board 12mm',
      description: 'Stronger moisture-resistant board suitable for partitions and reinforced ceiling applications in wet or high-humidity areas.',
      image: Moisture12mmImage
    }
  ];

  const processSteps = [
    'Site visit and measurement',
    'Design consultation and quotation',
    'Material selection',
    'Professional installation',
    'Finishing and quality check'
  ];


  const faqs = [
    {
      question: 'How long does gypsum ceiling installation take?',
      answer: 'Typically 2-5 days depending on the size and design.'
    },
    {
      question: 'Is gypsum ceiling durable?',
      answer: 'Yes, gypsum ceilings are long-lasting and require minimal maintenance.'
    },
    {
      question: 'Can gypsum ceilings be installed in bathrooms?',
      answer: 'Yes, using moisture-resistant gypsum boards.'
    },
    {
      question: 'Do you offer custom designs?',
      answer: 'Yes, we tailor designs to your style and space.'
    }
  ];

  const projectImages = useMemo(
    () => PROJECT_SHOWCASE.filter((project) => project.type === 'image'),
    []
  );

  const openImageSlider = (projectSrc) => {
    const selectedImageIndex = projectImages.findIndex((project) => project.src === projectSrc);
    if (selectedImageIndex !== -1) {
      setActiveImageIndex(selectedImageIndex);
    }
  };

  const closeImageSlider = () => {
    setActiveImageIndex(null);
  };

  const showNextImage = () => {
    setActiveImageIndex((currentIndex) => {
      if (currentIndex === null) {
        return currentIndex;
      }
      return (currentIndex + 1) % projectImages.length;
    });
  };

  const showPreviousImage = () => {
    setActiveImageIndex((currentIndex) => {
      if (currentIndex === null) {
        return currentIndex;
      }
      return (currentIndex - 1 + projectImages.length) % projectImages.length;
    });
  };

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Gypsum Ceiling Services',
    provider: {
      '@type': 'LocalBusiness',
      name: 'Techie Interiors',
      telephone: '+254748600208',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Nairobi',
        addressCountry: 'KE'
      }
    },
    areaServed: 'Nairobi',
    description:
      'Techie Interiors offers modern gypsum ceiling installation services and gypsum ceiling for sale in Nairobi with affordable pricing and expert installation for homes and offices.'
  };

  // VideoObject schemas — point mainEntityOfPage to the canonical watch pages
  // so Google knows /project/project-9 and /project/project-10 are the watch pages,
  // not the gypsum-ceiling service page
  const videoSchemas = [
    {
      '@context': 'https://schema.org',
      '@type': 'VideoObject',
      name: 'Ceiling Transformation Walkthrough',
      description: 'Video preview of before/after gypsum ceiling execution by Techie Interiors Nairobi.',
      thumbnailUrl: 'https://techieinteriors.co.ke/techLogo.jpeg',
      uploadDate: '2026-04-29',
      duration: 'PT1M',
      contentUrl: 'https://techieinteriors.co.ke/static/media/WhatsApp Video 2026-04-29 at 22.06.05.c6071f33176330f15986.mp4',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': 'https://techieinteriors.co.ke/project/project-9'
      },
      publisher: {
        '@type': 'Organization',
        name: 'Techie Interiors',
        logo: { '@type': 'ImageObject', url: 'https://techieinteriors.co.ke/techLogo.jpeg' }
      }
    },
    {
      '@context': 'https://schema.org',
      '@type': 'VideoObject',
      name: 'Custom Ceiling Installation Reel',
      description: 'Installation highlights from a completed gypsum ceiling project by Techie Interiors.',
      thumbnailUrl: 'https://techieinteriors.co.ke/techLogo.jpeg',
      uploadDate: '2026-04-29',
      duration: 'PT1M',
      contentUrl: 'https://techieinteriors.co.ke/static/media/WhatsApp Video 2026-04-29 at 22.06.20.21d49f127d153e664f07.mp4',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': 'https://techieinteriors.co.ke/project/project-10'
      },
      publisher: {
        '@type': 'Organization',
        name: 'Techie Interiors',
        logo: { '@type': 'ImageObject', url: 'https://techieinteriors.co.ke/techLogo.jpeg' }
      }
    }
  ];
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      }
    }))
  };

  return (
    <div className="gypsum-page">
      <SEO
        title="Gypsum Ceiling Services in Nairobi | Designs, Pricing & Installation"
        description="Get professional gypsum ceiling services in Nairobi from Techie Interiors. Explore board options, installation process, project gallery, and transparent pricing for homes and commercial spaces."
        image="/techLogo.jpeg"
        url="https://techieinteriors.co.ke/gypsum-ceiling"
        structuredData={[structuredData, faqSchema, ...videoSchemas]}
      />

      <section className="gypsum-hero">
        <div className="gypsum-hero-overlay" />
        <div className="gypsum-hero-content">
          <h1>Gypsum Ceiling Services in Nairobi – Modern, Affordable & Stylish Designs</h1>
          <p>
            Professional gypsum ceiling installation for homes, offices, and commercial spaces in Nairobi.
          </p>
          <div className="gypsum-hero-buttons">
            <a href="#contact-form" className="gypsum-btn gypsum-btn-primary">
              Get Free Quote
            </a>
            <Link to="/category/1" className="gypsum-btn gypsum-btn-secondary gypsum-btn-shop">
              Shop Gypsum Ceiling 
            </Link>
            <a href="#projects" className="gypsum-btn gypsum-btn-secondary">
              View Our Projects
            </a>
          </div>
        </div>
      </section>

      <section className="gypsum-section">
        <div className="gypsum-container">
          <h2>Gypsum Ceiling Solutions</h2>
          <p>
            Transform your home or commercial space with modern gypsum ceiling designs that add style, elegance,
            and value to your interior. At Techie Interiors, we design and install high-quality gypsum ceilings
            tailored to your space, budget, and preferred style-delivering clean finishes and long-lasting
            durability.
          </p>
          <p>
            Whether you want a simple modern ceiling or a bold statement design with lighting features, we create
            gypsum solutions that enhance the beauty and atmosphere of your space.
          </p>
        </div>
      </section>

      <section className="gypsum-section gypsum-alt">
        <div className="gypsum-container">
          <h2>Our Gypsum Ceiling Services Include:</h2>
          <div className="gypsum-list-grid">
            {services.map((service) => (
              <div key={service} className="gypsum-list-card">
                {service}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="gypsum-section">
        <div className="gypsum-container">
          <h2>Why Choose Our Gypsum Ceilings?</h2>
          <div className="gypsum-list-grid">
            {benefits.map((benefit) => (
              <div key={benefit} className="gypsum-list-card">
                {benefit}
              </div>
            ))}
          </div>
          <p className="gypsum-closing-note">
            From concept to installation, we deliver gypsum ceiling solutions that combine functionality, elegance,
            and professional craftsmanship.
          </p>
        </div>
      </section>

      <section className="gypsum-section gypsum-alt">
        <div className="gypsum-container">
          <h2>Types of Gypsum Boards</h2>

          <div className="gypsum-type-heading">
            <h3>Hada Gypsum Boards</h3>
            <p>
              Reliable and cost-effective gypsum boards suitable for residential and commercial ceiling and
              partition applications.
            </p>
          </div>
          <div className="gypsum-types-grid">
            {gypsumTypes.slice(0, 2).map((item) => (
              <article key={item.title} className="gypsum-type-card">
                <img src={item.image} alt={item.title} loading="lazy" decoding="async" />
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="gypsum-type-heading">
            <h3>Knauf Gypsum Boards</h3>
            <p>
              Premium-quality gypsum boards known for durability, consistency, and superior finishing performance.
            </p>
          </div>
          <div className="gypsum-types-grid">
            {gypsumTypes.slice(2, 4).map((item) => (
              <article key={item.title} className="gypsum-type-card">
                <img src={item.image} alt={item.title} loading="lazy" decoding="async" />
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="gypsum-type-heading">
            <h3>Gyproc Gypsum Boards</h3>
            <p>
              Trusted gypsum boards offering excellent surface finish and dependable performance for interior
              construction.
            </p>
          </div>
          <div className="gypsum-types-grid">
            {gypsumTypes.slice(4, 6).map((item) => (
              <article key={item.title} className="gypsum-type-card">
                <img src={item.image} alt={item.title} loading="lazy" decoding="async" />
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="gypsum-type-heading">
            <h3>Moisture Resistant Gypsum Boards</h3>
            <p>
              Specially designed gypsum boards for areas exposed to humidity and moisture, offering improved
              durability and resistance compared to standard boards.
            </p>
          </div>
          <div className="gypsum-types-grid">
            {gypsumTypes.slice(6, 8).map((item) => (
              <article key={item.title} className="gypsum-type-card">
                <img src={item.image} alt={item.title} loading="lazy" decoding="async" />
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="gypsum-section">
        <div className="gypsum-container">
          <h2>Gypsum Ceiling Prices in Nairobi</h2>
          <p>Gypsum ceiling prices vary depending on design, materials, and complexity.</p>
          <div className="gypsum-pricing-grid">
            <div className="gypsum-price-card">
              <h3>Standard gypsum ceiling</h3>
              <p>KES 1,800 - 2,500 per sqm</p>
            </div>
            <div className="gypsum-price-card">
              <h3>Decorative ceiling with lighting</h3>
              <p>KES 2,500 - 4,500 per sqm</p>
            </div>
            <div className="gypsum-price-card">
              <h3>Bulkheads and custom designs</h3>
              <p>KES 3,000 - 6,000 per sqm</p>
            </div>
          </div>
          <Link to="/category/1" className="gypsum-btn gypsum-btn-secondary gypsum-btn-shop">
            Shop Gypsum Ceiling
          </Link>
          <p className="gypsum-closing-note">📞 <Link to="/contact-us">Contact us</Link> for an accurate quotation based on your space and design.</p>
        </div>
      </section>

      <section className="gypsum-section gypsum-alt" id="projects">
        <div className="gypsum-container">
          <h2>Our Recent Gypsum Ceiling Projects</h2>
          <div className="gypsum-projects-grid">
            {PROJECT_SHOWCASE.map((project, index) => (
              <article key={project.src} className="gypsum-project-card">
                {project.type === 'image' ? (
                  <button
                    type="button"
                    className="gypsum-project-image-button"
                    onClick={() => openImageSlider(project.src)}
                    aria-label={`Open ${project.alt}`}
                  >
                    <img src={project.src} alt={project.alt} loading="lazy" decoding="async" />
                  </button>
                ) : (
                  <video controls preload="none" playsInline>
                    <source src={project.src} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>

      {activeImageIndex !== null && (
        <div className="gypsum-image-slider-overlay" onClick={closeImageSlider} role="presentation">
          <div className="gypsum-image-slider-content" onClick={(event) => event.stopPropagation()}>
            <button type="button" className="gypsum-image-slider-close" onClick={closeImageSlider} aria-label="Close image slider">
              x
            </button>
            <img
              src={projectImages[activeImageIndex].src}
              alt={projectImages[activeImageIndex].alt}
              className="gypsum-image-slider-image"
            />
            <button
              type="button"
              className="gypsum-image-slider-nav gypsum-image-slider-prev"
              onClick={showPreviousImage}
              aria-label="Show previous image"
            >
              <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              className="gypsum-image-slider-nav gypsum-image-slider-next"
              onClick={showNextImage}
              aria-label="Show next image"
            >
              <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      )}

      <section className="gypsum-section">
        <div className="gypsum-container">
          <h2>Our Installation Process</h2>
          <div className="gypsum-process-grid">
            {processSteps.map((step, index) => (
              <div key={step} className="gypsum-process-card">
                <span>{index + 1}</span>
                <p>{step}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="gypsum-section">
        <div className="gypsum-container">
          <h2>Frequently Asked Questions</h2>
          <div className="gypsum-faq-grid">
            {faqs.map((faq, index) => (
              <article key={faq.question} className="gypsum-faq-card">
                <h3>
                  {faq.question}
                </h3>
                <p>{faq.answer}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="tv-form-section gypsum-contact-section" id="contact-form">
        <div className="container gypsum-contact-container">
          <h2 className="section-title gypsum-contact-title">Ready to Upgrade Your Ceiling?</h2>
          <div className="form-wrapper gypsum-contact-grid">
            <div className="contact-info gypsum-contact-card">
              <h3>Get In Touch</h3>
              <p>Have questions about our gypsum ceiling solutions? We're here to help you create a beautiful and functional space.</p>
            <div className="info-item">
              <strong>Phone:</strong>
              <span>+254748600208</span>
            </div>
            <div className="info-item">
              <strong>Email:</strong>
              <span>info@techieinteriors.co.ke</span>
            </div>
            <div className="info-item">
              <strong>Location:</strong>
              <span>Nairobi, Kenya</span>
            </div>
            <div className="trust-line">
              <strong>We respond instantly.</strong>
            </div>
          </div>
            <div className="gypsum-quote-form-card">
              <QuoteForm serviceName="Gypsum Ceiling Solutions" />
            </div>
          </div>
        </div>
      </section>

      <section className="gypsum-section gypsum-alt gypsum-related-section">
        <div className="gypsum-container">
          <p className="gypsum-related-links">
            Explore <Link to="/services">all interior services</Link>, view our{' '}
            <Link to="/project">project portfolio</Link>, or request a{' '}
            <Link to="/contact-us">site visit in Nairobi</Link>. You can also check{' '}
            <Link to="/gypsum-ceilings-nairobi">gypsum ceilings in Nairobi</Link>,{' '}
            <Link to="/tv-gypsum-wall">TV wall units</Link>, and{' '}
            <Link to="/office-fitouts-kenya">commercial fit-outs in Kenya</Link>.
          </p>
        </div>
      </section>

    </div>
  );
};

export default GypsumCeilingSolutions;
